module.exports = __webpack_public_path__ + "img/new-tournaments.6fcf763f.png";